/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var customSwitcherBox = {

    engraveLimit: undefined,
    showExtraFields: undefined,
    primaryInputLabel: undefined,
    secondaryInputLabel: undefined,
    thirdInputLabel: undefined,
    propertiesMultiple: undefined,
  	map: undefined,


    initVariables() {
        if ($(".custom-switcher-content-wrapper").hasClass("limit-4807831060541")) {

            customSwitcherBox.ngraveLimit = 12;
        } else if ($('.engrave-text-switch-cont').hasClass('text-input-limited')) {
            customSwitcherBox.engraveLimit = 25;
        } else {
            customSwitcherBox.engraveLimit = 22;
        }

        if ($(".custom-switcher-content-wrapper").hasClass("multiple-engravings")) {

            customSwitcherBox.showExtraFields = true;
            customSwitcherBox.primaryInputLabel = "Front engraving";
            customSwitcherBox.secondaryInputLabel = "Back engraving";
            customSwitcherBox.propertiesMultiple = "Front engraving";
        } else {
            customSwitcherBox.showExtraFields = false;
            customSwitcherBox.primaryInputLabel = "Engrave text";
            customSwitcherBox.propertiesMultiple = "Text";
        }
        if ($(".productOption--ENGRAVING").hasClass("barEngraveOptions")) {
            customSwitcherBox.primaryInputLabel = "Front engraving";
            customSwitcherBox.secondaryInputLabel = "Left side engraving";
            customSwitcherBox.thirdInputLabel = "Right side engraving";
            customSwitcherBox.propertiesMultiple = "Front engraving";
        } else if ($(".productOption--ENGRAVING").hasClass("plateEngraveOptions")) {
            customSwitcherBox.primaryInputLabel = "Front engraving";
            customSwitcherBox.secondaryInputLabel = "Back engraving";
            customSwitcherBox.propertiesMultiple = "Front engraving";
        } else {
            customSwitcherBox.primaryInputLabel = "Engrave text";
            customSwitcherBox.propertiesMultiple = "Text";
        }
    },

  initEngravingFontChooser() {
        $(".engrave-font-chooser-item").on("click", function() {
          
            let container = $(this).closest('form');

        
            container.find('.engrave-font-chooser-item').not(this).removeClass('font-selected');
            $(this).addClass("font-selected");
            container.find("#engraving-font").val($(this).data("font"));

          	$('.open-product').find('.prop-type--Font span').html($(this).data("font"))
            container.find(".input-container-switch, .engrave-text-switch-cont").removeClass(function(index, css) {
                return (css.match(/\bengrave-font\S+/g) || []).join(' '); // removes anything that starts with "itemnx"
            });
            var fontClass = $(this).data("font").replace(/\s+/g, '-').toLowerCase();
            container.find('.input-container-switch, .engrave-text-switch-cont').addClass("engrave-font-" + fontClass);
          


            if ($('.product-custom-switcher-box').hasClass('mycircle-necklace-main')){
                var mainfont =  $(this).attr('data-font');
                //$('#line-item-dynamic #engraving-font').val(mainfont);
                    if (container.find('.engrave-text-switch-cont').hasClass("engrave-font-standard")) {
                    container.find(".engrave-font-disc-text").hide();
                    container.find(".input-sub").show();
                    } else {
                    container.find(".engrave-font-disc-text").show();
                    container.find(".input-sub").hide();
                    }
            }else{
              if (container.find('.input-container-switch').hasClass("engrave-font-standard")) {
                    container.find(".engrave-font-disc-text").hide();
                    container.find(".input-sub").show();
                    } else {
                    container.find(".engrave-font-disc-text").show();
                    container.find(".input-sub").hide();
                    }
                  drawStack();
            }
        });
    },

    initButtons() {
        $(document).ready(function() {
            if (window.location.href.indexOf("?morse") > -1) {
                $(".morse-btn").click();
            } else if (window.location.href.indexOf("?text") > -1) {
                $(".text-btn").click();
            } else if (window.location.href.indexOf("?coords") > -1) {
                $(".coords-btn").click();
            }

        });

        $(".coords-btn").click(function() {
            let container = $(this).closest('form');
            container.find("#morse-code").attr('name', '');
            container.find("#engraving-font").attr('name', 'properties[Font]');

            container.find(".coordinates-variant").show();
            container.find(".morse-variant").hide();
            container.find(".engrave-text-cont").hide();
            container.find(".engrave-font-chooser-wrapper").show();

          
            container.find(".coordinates-variant").addClass('active_bottom');
            container.find(".morse-variant").removeClass('active_bottom');
            container.find(".engrave-text-cont").removeClass('active_bottom');
          	
          	container.closest('.custom-bundle-form-item').find('.prop-type--Morse.code').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Text').remove();


            container.find(".text-engrave").removeClass("line-item-property__field");
            container.find("#morse-code").attr('name', '');
            container.find(".text-engrave-left").removeClass("line-item-property__field");
            container.find(".morse-property").removeClass("line-item-property__field");
            container.find(".text-engrave:not(.multiple-eng-hide-spec) input").attr('name', '');
          
          	container.find(".text-input-limit .text-engrave:not(.multiple-eng-hide-spec) textarea").attr('name', '');
            container.find(".text-engrave-left input").attr('name', '');
            container.find(".maps-latitude input").attr('name', 'properties[Latitude]');
            container.find(".maps-longitude input").attr('name', 'properties[Longitude]');


            container.find(".text-btn").removeClass("active-switcher");
            container.find(".coords-btn").addClass("active-switcher");
            container.find(".morse-btn").removeClass("active-switcher");
            container.find(".dynamic-landing-heading-hide").show();
            container.find(".dynamic-landing-heading-edit:not(.land-head-no-change)").text('4. Select your color')

        });


        $(".text-btn").click(function() {
            let container = $(this).closest('form');
            container.find(".maps-latitude input").attr('name', '');
            container.find(".maps-longitude input").attr('name', '');
            container.find(".text-engrave").addClass("line-item-property__field");
            container.find(".text-engrave-left").addClass("line-item-property__field");

			container.closest('.custom-bundle-form-item').find('.prop-type--Latitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Longitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Morse.code').remove();
          

            container.find(".text-engrave:not(.multiple-eng-hide-spec) input").attr('name', 'properties[' + customSwitcherBox.propertiesMultiple + ']');
			container.find(".text-input-limit .text-engrave:not(.multiple-eng-hide-spec) textarea").attr('name', 'properties[' + customSwitcherBox.propertiesMultiple + ']');
            container.find(".morse-property").removeClass("line-item-property__field");
            container.find(".coordinates-variant").hide();
            container.find(".morse-variant").hide();
            container.find(".engrave-text-cont").show();
          	container.find("#morse-code").attr('name', '');
            container.find(".engrave-font-chooser-wrapper").show();

            container.find(".coordinates-variant").removeClass('active_bottom');
            container.find(".morse-variant").removeClass('active_bottom');
            container.find(".engrave-text-cont").addClass('active_bottom');

            container.find(".dynamic-landing-heading-hide").show();
            container.find(".dynamic-landing-heading-edit:not(.land-head-no-change)").text('4. Select your color')
            container.find(".text-btn").addClass("active-switcher");
            container.find(".coords-btn").removeClass("active-switcher");
            container.find(".morse-btn").removeClass("active-switcher");

            container.find('.text-input-limit').keyup(function(e) {
                console.log("text-input running");
                if (e.keyCode === 8) return; // Backspace
                var new_stuff = $(this).val();
                new_stuff = new_stuff.replace(/[\n\r]+/g, ""); // clean out newlines, so we dont get dups!
                new_stuff = new_stuff.replace(/(.{12})/g, "$1\r");
                $(this).val(new_stuff);
            });
            container.find("#line-item-dynamic input").attr('name', 'properties[Font]');

        });

        $(".morse-btn").click(function() {
            let container = $(this).closest('form');
            container.find(".maps-latitude input").attr('name', '');
            container.find(".maps-longitude input").attr('name', '');

            container.find(".coordinates-variant").hide();
            container.find(".morse-variant").show();
            container.find(".engrave-text-cont").hide();

            container.find(".coordinates-variant").removeClass('active_bottom');
            container.find(".morse-variant").addClass('active_bottom');
            container.find(".engrave-text-cont").removeClass('active_bottom');
          
          	container.closest('.custom-bundle-form-item').find('.prop-type--Latitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Longitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Text').remove();

            container.find(".text-engrave").removeClass("line-item-property__field");
            container.find(".text-engrave-left").removeClass("line-item-property__field");
            container.find(".engrave-font-chooser-wrapper").hide();

            container.find("#line-item-dynamic input").attr('name', '');
            container.find('.barEngraveExtraOpt').attr('name', '');
            container.find('.text-engrave-left input').attr('name', '');
            container.find('#text-engrave').attr('name', '');
            container.find(".dynamic-landing-heading-hide").hide();
            container.find(".dynamic-landing-heading-edit").text('3. Select your color')
            container.find("#morse-code").attr('name', 'properties[Morse code]');
            container.find(".morse-property").addClass("line-item-property__field");

            container.find('.morse-variant').show();
            container.find(".text-btn").removeClass("active-switcher");
            container.find(".coords-btn").removeClass("active-switcher");
            container.find(".morse-btn").addClass("active-switcher");

        });
    }
};
 function lowStockCounter(){
    var minNumber = 59;
    var maxNumber = 198

    var randomNumber = randomNumberFromRange(minNumber, maxNumber);

    function randomNumberFromRange(min,max)
    {
        return Math.floor(Math.random()*(max-min+1)+min);
    }
    console.log("stockCOunt", randomNumber);
    $(".low-stock-notice span").html(randomNumber);
  }

function photoGuideModal() {
  $('.guide-btn').click( function(){
    console.log("test");
    $('.photo-guide-modal').show();
    
  });
    $('.photo-guide-close').click( function(){
    
    $('.photo-guide-modal').hide();
    
  });
}

function titoCampDetection() {
 
  if (window.location.href.indexOf("?tiktok") > -1) {
     console.log("Tiktok campaign triggered");
     $('body').addClass("tiktok-campaign");
    
    sessionStorage.setItem("tiktokCamp", "yes");
  } 
  
}
$(document).ready(function(){
  
  if(sessionStorage.getItem("tiktokCamp") == "yes"){
     console.log("Tiktok campaign triggered");
     $('body').addClass("tiktok-campaign");
    
  } 
console.log("viewcart is active and running")
        if (window.location.href.indexOf("?viewcart=true") > -1) {
        console.log("Viewcart is in URL");
        $('.Drawer--Open').get(0).click()
}   
lowStockCounter()  
photoGuideModal()
titoCampDetection()
if (window.closed) {
  sessionStorage.setItem("tiktokCamp", "no")
}
});
$(document).ready(function(){
  $(document).on('change' , '.ProductItem__Info .ProductItem__ColorSwatchItem', function(){
   $(this).closest('.ProductItem__Wrapper').find('.customvariant_img ').addClass('hide');
  });
});
$(document).on('click', '.guide-btn', function(){
   $('.photo-guide-modal').show();
   //photoGuideModal();
  }); 
$(document).ready(function(){
           $(".productOptionAddEngrave").click(function(){
                           if($(this).hasClass("prod-opt-ex-engrave--hide")){
               $(this).removeClass("prod-opt-ex-engrave--hide");
           } else {
               $(this).addClass("prod-opt-ex-engrave--hide");
           }
           }); 
           
       });

$(document).ready(function(){
               $(".prodOptAddEng--arrow").click(function(){
                       if($(".productOptionAddEngrave").hasClass("prod-opt-ex-engrave--hide")){
                 $(".productOptionAddEngrave").removeClass("prod-opt-ex-engrave--hide");
               } else {
                 $(".productOptionAddEngrave").addClass("prod-opt-ex-engrave--hide");
               }
               }); 
		})

 if ($(".productOption--ENGRAVING").hasClass("barEngraveOptions")){
								var engravingsPropertiesSecond = "Left engraving" ;
						 		var engravingsPropertiesThird = "Right engraving";
							 } else {
								 var engravingsPropertiesSecond = "Back engraving";
							 }

			$(".productOptionAddEngrave .HorizontalList__Item").click(function(event){
             $(".prodExOpt--selected").text($(this).find(".eng-option-label").text());
              
               var SelectText = $(this).find(".eng-option-label").data("tooltip");
                if( SelectText === "SILVER CIRCLE"){
                  var ThirdEngraveCIRCLE  = ('SILVER CIRCLE ENGRAVING'); 
                  $('.line-item-property__field.text-engrave label p').text('SILVER CIRCLE TEXT ENGRAVING');
                  $(".line-item-property__field #text-engrave").attr('name', 'properties['+ ThirdEngraveCIRCLE +']');
                  $(".multiple-engraving-field-hide").hide();
                  $(".multiple-engraving-field-hide #text-engrave").attr('name', '');
                  $(".multiple-engraving-field-hide #text-engrave-left").attr('name', '');
                return;
                }else if(SelectText === "GOLD CIRCLE"){
                  var ThirdEngraveGOLD  = ('GOLD CIRCLE ENGRAVING'); 
                  $('.line-item-property__field.text-engrave label p').text('GOLD CIRCLE TEXT ENGRAVING');
                  $(".line-item-property__field #text-engrave").attr('name', 'properties['+ ThirdEngraveGOLD +']');
                  $(".multiple-engraving-field-hide").hide();
                  $(".multiple-engraving-field-hide #text-engrave").attr('name', '');
                  $(".multiple-engraving-field-hide #text-engrave-left").attr('name', '');
                  return;
                }else if(SelectText === "ROSE GOLD CIRCLE"){
                  var ThirdEngraveROSEGOLD  = ('ROSE GOLD CIRCLE'); 
                  $('.line-item-property__field.text-engrave label p').text('ROSE GOLD CIRCLE TEXT ENGRAVING');
                  $(".line-item-property__field #text-engrave").attr('name', 'properties['+ ThirdEngraveROSEGOLD +']');
                  $(".multiple-engraving-field-hide").hide();
                  $(".multiple-engraving-field-hide #text-engrave").attr('name', '');
                  $(".multiple-engraving-field-hide #text-engrave-left").attr('name', '');
                  return;
                }else if( SelectText === "SILVER/GOLD CIRCLE ($10)"){
                  var SecondEngraveText  = ('GOLD CIRCLE ENGRAVING'); 
                  var SilverText = ('SILVER CIRCLE TEXT ENGRAVING');
                  $(".multiple-engraving-field-hide").show();
                  $(".multiple-eng-hide-spec").hide();
                  $('.line-item-property__field.text-engrave label p').text('SILVER CIRCLE TEXT ENGRAVING');
                  $(".line-item-property__field #text-engrave").attr('name', 'properties['+ SilverText +']');
                  $(".multiple-engraving-field-hide label").text('GOLD CIRCLE TEXT ENGRAVING');
                  $(".multiple-engraving-field-hide #text-engrave.barEngraveExtraOpt").attr('name', '');
                  $(".multiple-engraving-field-hide #text-engrave-left").attr('name', 'properties['+ SecondEngraveText +']');
                  return;
                }else if( SelectText === "GOLD/ROSE GOLD CIRCLE ($10)"){
                  var SecondEngraveText  = ('ROSE GOLD CIRCLE ENGRAVING'); 
                  var GOLDText = ('GOLD ENGRAVING TEXT ENGRAVING');
                  $(".multiple-engraving-field-hide").show();
                  $(".multiple-eng-hide-spec").hide();
                  $('.line-item-property__field.text-engrave label p').text('GOLD TEXT ENGRAVING');
                  $(".line-item-property__field #text-engrave").attr('name', 'properties['+ GOLDText +']');
                  $(".multiple-engraving-field-hide label").text('ROSE GOLD CIRCLE TEXT ENGRAVING');
                  $(".multiple-engraving-field-hide #text-engrave.barEngraveExtraOpt").attr('name', '');
                  $(".multiple-engraving-field-hide #text-engrave-left").attr('name', 'properties['+ SecondEngraveText +']');
                  return;
                }else if( SelectText === "SILVER/ROSE GOLD CIRCLE ($10)"){
                  var SecondEngraveText  = ('ROSE GOLD CIRCLE ENGRAVING'); 
                  var SilverText = ('SILVER CIRCLE TEXT ENGRAVING');
                  $(".multiple-engraving-field-hide").show();
                  $(".multiple-eng-hide-spec").hide();
                  $('.line-item-property__field.text-engrave label p').text('SILVER CIRCLE TEXT ENGRAVING');
                  $(".line-item-property__field #text-engrave").attr('name', 'properties['+ SilverText +']');
                  $(".multiple-engraving-field-hide label").text('ROSE GOLD CIRCLE TEXT ENGRAVING');
                  $(".multiple-engraving-field-hide #text-engrave.barEngraveExtraOpt").attr('name', '');
                  $(".multiple-engraving-field-hide #text-engrave-left").attr('name', 'properties['+ SecondEngraveText +']');
                  return;
                }else if( SelectText === "TRICOLOR CIRCLE ($15)"){
                  var SecondEngraveText  = ('ROSE GOLD CIRCLE ENGRAVING'); 
                  var ThirdEngraveText  = ('SILVER CIRCLE ENGRAVING'); 
                  var GOLDText = ('GOLD CIRCLE TEXT ENGRAVING');
                  $(".multiple-engraving-field-hide").show();
                  $(".multiple-eng-hide-spec").show();
                  $('.line-item-property__field.text-engrave label p').text('Gold CIRCLE TEXT ENGRAVING');
                  $(".line-item-property__field #text-engrave").attr('name', 'properties['+ GOLDText +']');
                  $(".multiple-engraving-field-hide label").text('ROSE GOLD CIRCLE TEXT ENGRAVING');
                  $('.multiple-engraving-field-hide.multiple-eng-hide-spec label').text('SILVER CIRCLE TEXT ENGRAVING');
                  $(".multiple-engraving-field-hide #text-engrave.barEngraveExtraOpt").attr('name', 'properties['+ ThirdEngraveText +']');
                  $(".multiple-engraving-field-hide #text-engrave-left").attr('name', 'properties['+ SecondEngraveText +']');
                  return;
                }else {
                  var ENGRAVEText = ('ENGRAVE TEXT');
                  $(".multiple-engraving-field-hide").hide();
                  $(".multiple-engraving-field-hide #text-engrave").attr('name', '');
                  $(".multiple-engraving-field-hide #text-engrave-left").attr('name', '');
                  $('.line-item-property__field.text-engrave label p').text('ENGRAVE TEXT');
                  $(".line-item-property__field #text-engrave").attr('name', 'properties['+ ENGRAVEText +']');
                }    
             if($(this).find(".eng-option-label").data("tooltip") === "2 ENGRAVINGS"){
               $(".multiple-engraving-field-hide").show();
               $(".multiple-eng-hide-spec").hide();

               $(".multiple-engraving-field-hide #text-engrave.barEngraveExtraOpt").attr('name', '');
               $(".multiple-engraving-field-hide #text-engrave-left").attr('name', 'properties['+ engravingsPropertiesSecond +']');
               return;        
             } else if($(this).find(".eng-option-label").data("tooltip") === "3 ENGRAVINGS") {
               $(".multiple-engraving-field-hide").show();
               $(".multiple-eng-hide-spec").show();
               $(".multiple-engraving-field-hide #text-engrave.barEngraveExtraOpt").attr('name', 'properties['+ engravingsPropertiesThird +']');
               $(".multiple-engraving-field-hide #text-engrave-left").attr('name', 'properties['+ engravingsPropertiesSecond +']');             
             } else {
               $(".multiple-engraving-field-hide").hide();
               $(".multiple-engraving-field-hide #text-engrave").attr('name', '');
               $(".multiple-engraving-field-hide #text-engrave-left").attr('name', '');
               
             }            
           });   
          document.addEventListener('variant:changed', function(event) {
          var variant = event.detail.variant; // Gives you access to the whole variant details
          
          $(".productOptionAddEngrave").addClass("prod-opt-ex-engrave--hide");
          });



// CC047: Homepage Aesthetics Design js for (Rest of World)ROW, except US & Canada

(function() {
  function fetchCountryCode() {
    fetch('https://www.customcuff.co/browsing_context_suggestions.json')
      .then(response => response.json())
      .then(data => {
        const countryCode = data.detected_values.country.handle;
        document.body.setAttribute('data-country-code', countryCode);
        sessionStorage.setItem('countryCode', countryCode); // Save the country code in session storage
        if (countryCode !== 'US' && countryCode !== 'CA') {
          document.body.classList.add('CC047-Homepage');
        }
       if (countryCode !== 'Uk') {
          document.body.classList.add('hidden-UK-87');
        }
      })
      .catch(error => console.error('Error fetching the JSON:', error));
  }

  document.addEventListener("DOMContentLoaded", function() {
    var countryCode = sessionStorage.getItem('countryCode');
    if (countryCode) {
      document.body.setAttribute('data-country-code', countryCode);
      if (countryCode !== 'US' && countryCode !== 'CA') {
        document.body.classList.add('CC047-Homepage');
      }
        if (countryCode !== 'Uk') {
          document.body.classList.add('hidden-UK-87');
        }
    } else {
      fetchCountryCode();
    }
  });
})(); 






  function startCountdownhp(startTimeHP, endTimeHP) {
    function updateCountdownHP() {
        const now = new Date().getTime();

        if (now < startTimeHP) {
            document.getElementById("countdown-hp").innerHTML = "Sale Starts Soon";
            return;
        }

        if (now > endTimeHP) {
            document.getElementById("countdown-hp").innerHTML = "Sale Ended";
            return;
        }

        const remainingTimeHP = endTimeHP - now;
        const days = Math.floor(remainingTimeHP / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remainingTimeHP % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((remainingTimeHP % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remainingTimeHP % (1000 * 60)) / 1000);

        document.getElementById("days-hp").textContent = days;
        document.getElementById("hours-hp").textContent = hours;
        document.getElementById("minutes-hp").textContent = minutes;
        document.getElementById("seconds-hp").textContent = seconds;
    }

    setInterval(updateCountdownHP, 1000);
    updateCountdownHP();
}

  
const startTimeHP = new Date("2025-03-24T00:00:00Z").getTime();
const endTimeHP = new Date("2025-04-20T23:59:59Z").getTime();

startCountdownhp(startTimeHP, endTimeHP);
